import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Input from "@mui/material/Input";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { AiOutlineClose } from "react-icons/ai";
import { BiAddToQueue } from "react-icons/bi";
import { BsCameraFill } from "react-icons/bs";
import { FaFileContract } from "react-icons/fa";
import { toast } from "react-toastify";
import termo from "../assets/termo.docx";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import CustomTextField from "../components/CustomTextField";
import DashboardContext from "../context/DashboardContext";
import {
  getNodeCategories,
  getNodeCities,
  getNodeStates,
  postNodeEmail,
  pushAddressEstablishment,
  pushContractEstablishment,
  pushDiscountEstablishment,
  pushImageEstablishment,
  setNewEstablishment,
  updateEstablishment,
} from "../services/SubmitEstablishment";
export default function NewEstablishment() {
  const navigation = useNavigate();
  // VALORES INICIAIS DOS ESTADOS
  const {
    clientUser,
    clientPassword,
    clientId,
    qrcodeLink,
    setQrcodeLink,
    nodeToken,
  } = useContext(DashboardContext);
  const INITIAL_INPUTS_VALUE = {
    name: "",
    about: "",
    responsibleName: "",
    responsiblePhone: "",
    categoryId: "",
    cityId: "",
    virtualStore: "",
    exclusive: "",
    rules: "",
    keyWords: "",
  };
  const addressType = {
    name: "",
    cityId: "",
    address: "",
    latitude: "",
    longitude: "",
    telephone: "",
  };
  const dicountType = {
    description: "",
    rule: "",
    summary: "",
    typeDiscount: "%",
  };

  // ESTADOS DA APLICAÇÃO

  const [formInputs, setFormInputs] = useState(
    JSON.parse(sessionStorage.getItem("formInputs")) || INITIAL_INPUTS_VALUE
  );
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [step, setStep] = useState(0);
  const [addressArray, setAddressArray] = useState([addressType]);
  const [discountArray, setDiscountArray] = useState([dicountType]);
  const [contract, setContract] = useState(null);
  const [cover, setCover] = useState(null);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [comments, setComments] = useState("");
  // check Disabled Buttons
  function checkStep1() {
    if (
      formInputs.name &&
      formInputs.about &&
      formInputs.responsibleName &&
      formInputs.responsiblePhone &&
      formInputs.rules &&
      formInputs.exclusive !== "" &&
      formInputs.virtualStore !== "" &&
      formInputs.cityId &&
      formInputs.categoryId &&
      formInputs.telephone
    ) {
      if (
        formInputs.virtualStore &&
        (!formInputs.coupon ||
          !formInputs.couponDescription ||
          !formInputs.store)
      ) {
        return true;
      }
      return false;
    }
    return true;
  }
  function checkStep2() {
    if (!addressArray.length) {
      return true;
    }
    for (let i = 0; i < addressArray.length; i++) {
      const { name, cityId, address } = addressArray[i];
      if (!name || !cityId || !address) {
        return true; // Alguma chave está faltando ou não está preenchida
      }
    }
    return false;
  }
  function checkStep3() {
    if (!discountArray.length) {
      return true;
    }
    for (let i = 0; i < discountArray.length; i++) {
      const { summary, rule, description } = discountArray[i];
      if (!summary || !rule || !description) {
        return true; // Alguma chave está faltando ou não está preenchida
      }
    }
    return false;
  }
  function checkStep4() {
    if (!image || !cover || !contract) {
      return true;
    }
    return false;
  }
  function checkDisabledButton() {
    if (step === 1) {
      return checkStep1();
    }
    if (step === 2) {
      return checkStep2();
    }
    if (step === 3) {
      return checkStep3();
    }
    if (step === 4) {
      return checkStep4();
    }
    if (step === 5) {
      return false;
    }
  }

  //

  async function ExecutePromises(establishmentId) {
    const bannerForm = new FormData();
    const logoForm = new FormData();
    const contractForm = new FormData();

    bannerForm.append("file", cover);
    logoForm.append("file", image);
    contractForm.append("file", contract);

    //PROMISES
    try {
      const pushDiscount = pushDiscountEstablishment({
        id: establishmentId,
        array: discountArray,
        token: nodeToken,
      });
      const pushAddress = !formInputs.virtualStore
        ? pushAddressEstablishment({
            id: establishmentId,
            array: addressArray,
            token: nodeToken,
          })
        : null;
      const pushLogo = pushImageEstablishment({
        id: establishmentId,
        FormData: logoForm,
        token: nodeToken,
        type: "image",
      });
      const pushBanner = pushImageEstablishment({
        id: establishmentId,
        FormData: bannerForm,
        token: nodeToken,
        type: "cover",
      });
      const pushContract = pushContractEstablishment({
        id: establishmentId,
        formData: contractForm,
        token: nodeToken,
      });
      const pushComments = comments
        ? await updateEstablishment({
            id: establishmentId,
            body: { comments },
            token: nodeToken,
          })
        : null;

      const executeAllPromises = await Promise.all([
        pushDiscount,
        pushAddress,
        pushBanner,
        pushContract,
        pushLogo,
      ]);
      const sendEmail = await postNodeEmail({
        id: establishmentId,
        token: nodeToken,
      });
      setIsLoading(false);
      toast.success("Estabelecimento adicionado para análise");
      navigation("/panel");
    } catch (err) {
      setIsLoading(false);
      console.log(err);
      toast.error(
        "erro ao socilitar aprovação para estabelecimento , solicite novamente mais tarde"
      );
    }
  }

  // GETS
  // ----- lista de categorias
  const getCategories = async () => {
    const categoriesFetched = await getNodeCategories();
    setCategories(categoriesFetched);
  };

  // ----- lista de estados
  const getStates = async () => {
    const statesFetched = await getNodeStates();
    setStates(statesFetched);
  };

  // ----- lista de cidades
  const getCities = async (state) => {
    const citiesFetched = await getNodeCities(state);
    setCities(citiesFetched);
  };

  // HANDLERS

  // ----- inputs tipo text do formulário
  const handleTextInputsChange = ({ target: { name, value } }) => {
    setFormInputs((prevState) => ({ ...prevState, [name]: value }));
    sessionStorage.setItem("formInputs", JSON.stringify(formInputs));
  };

  // ----- inputs tipo arquivo do formulário
  const handleFileInputsChange = ({ target: { name, files } }) => {
    const fd = new FormData();
    fd.append("arquivo", files[0]);
    setFormInputs((prevState) => ({ ...prevState, [name]: files[0] }));
    console.log(files[0]);
  };

  // ----- submit do formulário
  const submitNewEstablishment = async (event) => {
    setIsLoading(true);
    const pushEstablishment = await setNewEstablishment({
      token: nodeToken,
      establishment: formInputs,
    });
    if (!pushEstablishment.establishmentId) {
      toast.error(
        "Erro ao Cadastrar estabelecimento , tente novamente mais tarde"
      );
      setStep(1);
      setIsLoading(false);
      return;
    }
    const allPromises = await ExecutePromises(
      pushEstablishment.establishmentId
    );
  };

  function handleChangeStep({ type }) {
    if (step === 5 && type === "more") {
      submitNewEstablishment();
      return;
    }
    if (step === 1 && type === "more" && formInputs.virtualStore) {
      setStep((state) => state + 2);
      return;
    }
    if (step === 3 && type === "less" && formInputs.virtualStore) {
      setStep((state) => state - 2);
      return;
    }
    if (type === "more") {
      setStep((state) => state + 1);
      return;
    }
    if (type === "less" && step > 0) {
      setStep((state) => state - 1);
      return;
    }
  }
  // USE EFFECTS

  // ----- quando a página carrega
  useEffect(() => {
    getCategories();
    getStates();
    console.log(formInputs);
  }, []);

  // ----- quando um estado é selecionado

  // RETORNO

  return (
    <Container>
      {/* CONTAINER PRINCIPAL */}
      <CustomContainer
        style={{ padding: "32px 48px" }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          mb: 3,
          minWidth: 1100,
        }}
      >
        {/* TÍTULO DA PÁGINA */}
        <Typography
          color="primary"
          component="h2"
          mb={4}
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          variant="h4"
        >
          <EditIcon fontSize="md" sx={{ mr: 1 }} />
          Cadastrar{" "}
          {step === 2
            ? "Endereços"
            : step === 3
            ? "Descontos"
            : step === 4
            ? "Arquivos"
            : step === 5
            ? "Observação"
            : "Estabelecimento"}
        </Typography>

        {/* FORMULÁRIO DE CADASTRO */}

        {step === 0 ? (
          <Stack sx={{ alignItems: "center", marginBottom: 5 }}>
            <Typography
              variant="h6"
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "center",
              }}
              mb={3}
            >
              Nos próximos passos, você irá cadastrar as informações cadastrais
              iniciais de um novo parceiro do Clube Certo. Para realizar a
              análise do parceiro, precisamos inicialmente de alguns dados
              básicos. Após o cadastro, você poderá verificar o andamento
              através do painel de parceiros.{<br />} Obs: Para otimizar seu
              tempo, é importante garantir que o termo de parcerias tenha sido
              assinado pelo responsável legal do estabelecimento.
            </Typography>
            <a href={termo} download>
              Não tem o Termo de parcerias?
            </a>
          </Stack>
        ) : (
          <></>
        )}
        <Stack spacing={3}>
          {/* PRIMEIRA LINHA */}
          {step === 1 ? (
            <>
              <Stack direction="row" spacing={2}>
                {/* NOME DO ESTABELECIMENTO */}
                <CustomTextField
                  autoComplete="off"
                  color="primary"
                  label="Nome do estabelecimento"
                  name="name"
                  onChange={handleTextInputsChange}
                  required
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.name}
                  variant="outlined"
                />

                {/* CATEGORIA */}
                <CustomTextField
                  color="primary"
                  label="Categoria"
                  name="categoryId"
                  onChange={handleTextInputsChange}
                  required
                  select
                  size="small"
                  sx={{ width: "100%" }}
                  value={formInputs.categoryId}
                  variant="outlined"
                >
                  <MenuItem disabled value=""></MenuItem>
                  {categories?.map(({ id, name }) => (
                    <MenuItem key={id + name} value={Number(id)}>
                      {name}
                    </MenuItem>
                  ))}
                </CustomTextField>
              </Stack>

              {/* SEGUNDA LINHA */}
              <Stack direction="row" spacing={2}>
                {/* SOBRE */}
                <CustomTextField
                  required
                  autoComplete="off"
                  color="primary"
                  label="Sobre"
                  multiline
                  name="about"
                  onChange={handleTextInputsChange}
                  rows={5}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.about}
                  variant="outlined"
                />
                <CustomTextField
                  required
                  autoComplete="off"
                  color="primary"
                  label="Regra Geral"
                  multiline
                  name="rules"
                  onChange={handleTextInputsChange}
                  rows={5}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.rules}
                  variant="outlined"
                />
              </Stack>
              <Stack direction={"row"} spacing={2}>
                <CustomTextField
                  required
                  color="primary"
                  label="Estado"
                  name="estado"
                  onChange={({ target }) => {
                    getCities(target.value);
                  }}
                  select
                  size="small"
                  sx={{ width: "100%" }}
                  variant="outlined"
                >
                  <MenuItem disabled value=""></MenuItem>
                  {!!states &&
                    states?.map(({ id, name }) => (
                      <MenuItem key={id + name} value={Number(id)}>
                        {name}
                      </MenuItem>
                    ))}
                </CustomTextField>
                <CustomTextField
                  required
                  color="primary"
                  label="Cidade"
                  name="cityId"
                  onChange={handleTextInputsChange}
                  select
                  size="small"
                  sx={{ width: "100%" }}
                  value={formInputs.cityId}
                  variant="outlined"
                >
                  {!!cities &&
                    cities?.map(({ id, name }) => (
                      <MenuItem key={id + name} value={Number(id)}>
                        {name}
                      </MenuItem>
                    ))}
                  <MenuItem disabled value=""></MenuItem>
                </CustomTextField>
              </Stack>
              {/* TERCEIRA LINHA */}
              <Stack direction="row" spacing={2}>
                {/* TELEFONE 1 */}
                <CustomTextField
                  required
                  autoComplete="off"
                  color="primary"
                  label="Telefone"
                  name="telephone"
                  onChange={handleTextInputsChange}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.telephone}
                  variant="outlined"
                />
                <CustomTextField
                  autoComplete="off"
                  required
                  color="primary"
                  label="Nome Responsável"
                  name="responsibleName"
                  onChange={handleTextInputsChange}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.responsibleName}
                  variant="outlined"
                />
                {/* TELEFONE RESPONSAVEL */}
                <CustomTextField
                  required
                  autoComplete="off"
                  color="primary"
                  label="Telefone Responsável"
                  name="responsiblePhone"
                  onChange={handleTextInputsChange}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.responsiblePhone}
                  variant="outlined"
                />
              </Stack>

              {/* QUARTA LINHA */}
              <Stack direction="row" spacing={2}>
                {/* SITE */}
                <CustomTextField
                  autoComplete="off"
                  color="primary"
                  label="Site"
                  name="site"
                  onChange={handleTextInputsChange}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.site}
                  variant="outlined"
                />

                {/* INSTAGRAM */}
                <CustomTextField
                  autoComplete="off"
                  color="primary"
                  label="Instagram"
                  name="instagram"
                  onChange={handleTextInputsChange}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.instagram}
                  variant="outlined"
                />
                <CustomTextField
                  autoComplete="off"
                  color="primary"
                  label="WhatsApp"
                  name="whatsapp"
                  onChange={handleTextInputsChange}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.whatsapp}
                  variant="outlined"
                />

                {/* ORDEM DE EXIBIÇÃO */}
              </Stack>
              {/* SEXTA LINHA */}
              <Stack direction="row" spacing={2}>
                {/* LOJA VIRTUAL */}
                <CustomTextField
                  required
                  color="primary"
                  label="É loja virtual?"
                  name="virtualStore"
                  onChange={handleTextInputsChange}
                  select
                  size="small"
                  sx={{ width: "100%" }}
                  value={formInputs.virtualStore}
                  variant="outlined"
                >
                  <MenuItem disabled value=""></MenuItem>
                  <MenuItem value={true}>Sim</MenuItem>
                  <MenuItem value={false}>Não</MenuItem>
                </CustomTextField>
                <CustomTextField
                  required
                  color="primary"
                  label="Parceiro Exclusivo ?"
                  name="exclusive"
                  onChange={handleTextInputsChange}
                  select
                  size="small"
                  sx={{ width: "100%" }}
                  value={formInputs.exclusive}
                  variant="outlined"
                >
                  <MenuItem disabled value=""></MenuItem>
                  <MenuItem value={false}>Não</MenuItem>
                  <MenuItem value={true}>Sim</MenuItem>
                </CustomTextField>
                {/* LATITUDE */}
                {/* { !Number(formInputs.lojaVirtual) &&
                  formInputs.lojaVirtual !== "" && (
                    <CustomTextField
                      autoComplete="off"
                      color="primary"
                      label="Latitude"
                      name="latitude"
                      onChange={handleTextInputsChange}
                      size="small"
                      sx={{ width: "341.33px" }}
                      type="text"
                      value={formInputs.latitude}
                      variant="outlined"
                    />
                  )} */}
                {/* LONGITUDE */}
                {/* {!Number(formInputs.lojaVirtual) &&
                  formInputs.lojaVirtual !== "" && (
                    <CustomTextField
                      autoComplete="off"
                      color="primary"
                      label="Longitude"
                      name="longitude"
                      onChange={handleTextInputsChange}
                      size="small"
                      sx={{ width: "341.33px" }}
                      type="text"
                      value={formInputs.longitude}
                      variant="outlined"
                    />
                  )} */}
              </Stack>

              {/* NONA LINHA */}
              {formInputs.virtualStore && step === 1 && (
                <Stack direction="row" spacing={2}>
                  {/* CUPOM */}
                  <CustomTextField
                    autoComplete="off"
                    color="primary"
                    label="Cupom"
                    name="coupon"
                    onChange={handleTextInputsChange}
                    size="small"
                    sx={{ width: "100%" }}
                    type="text"
                    value={formInputs.coupon}
                    variant="outlined"
                  />

                  {/* DESCRIÇÃO DO CUPOM */}
                  <CustomTextField
                    autoComplete="off"
                    color="primary"
                    label="Descrição do cupom"
                    name="couponDescription"
                    onChange={handleTextInputsChange}
                    size="small"
                    sx={{ width: "100%" }}
                    type="text"
                    value={formInputs.couponDescription}
                    variant="outlined"
                  />

                  {/* LINK */}
                  <CustomTextField
                    required
                    autoComplete="off"
                    color="primary"
                    label="Link"
                    name="store"
                    onChange={handleTextInputsChange}
                    size="small"
                    sx={{ width: "100%" }}
                    type="text"
                    value={formInputs.store}
                    variant="outlined"
                  />
                </Stack>
              )}
              {/*          
              <Stack direction="row" spacing={2}>
     
                <CustomTextField
                  autoComplete="off"
                  color="primary"
                  label="Desconto"
                  multiline
                  name="desconto"
                  onChange={handleTextInputsChange}
                  rows={3}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.desconto}
                  variant="outlined"
                />

                <CustomTextField
                  autoComplete="off"
                  color="primary"
                  label="Regra"
                  multiline
                  name="regra"
                  onChange={handleTextInputsChange}
                  rows={3}
                  size="small"
                  sx={{ width: "100%" }}
                  type="text"
                  value={formInputs.regra}
                  variant="outlined"
                />
              </Stack> */}
            </>
          ) : (
            <></>
          )}
          {!formInputs.virtualStore && step === 2 ? (
            addressArray?.map((el, index) => (
              <>
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent={"flex-end"}
                  alignItems={"flex-end"}
                >
                  {index > 0 && (
                    <AiOutlineClose
                      style={{ cursor: "pointer" }}
                      size={30}
                      color="red"
                      onClick={() => {
                        if (index > 0) {
                          setAddressArray(
                            addressArray.filter((el, mapIndex) => {
                              return mapIndex !== index;
                            })
                          );
                        }
                      }}
                    />
                  )}
                  <BiAddToQueue
                    style={{ cursor: "pointer" }}
                    size={30}
                    color="#4b9853"
                    onClick={() => {
                      setAddressArray([...addressArray, addressType]);
                      setTimeout(() => {
                        window.scrollTo({
                          top: 999999,
                          behavior: "smooth",
                        });
                      }, 100);
                    }}
                  />
                </Stack>
                <Stack spacing={3}>
                  <Typography variant="h5" color={"#4b9853"}>
                    Endereço {index + 1}
                  </Typography>
                  <Stack direction="row" spacing={2}>
                    <CustomTextField
                      required
                      autoComplete="off"
                      color="primary"
                      label="Endereço"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].address = target.value;
                        setAddressArray(newAddress);
                      }}
                      size="small"
                      sx={{ width: "100%" }}
                      type="text"
                      value={addressArray[index].address}
                      variant="outlined"
                    />
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <CustomTextField
                      required
                      autoComplete="off"
                      color="primary"
                      label="Nome do endereço"
                      name="name"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].name = target.value;
                        setAddressArray(newAddress);
                      }}
                      size="small"
                      sx={{ width: "100%" }}
                      type="text"
                      value={addressArray[index].name}
                      variant="outlined"
                    />
                    <CustomTextField
                      required
                      color="primary"
                      label="Estado"
                      name="estado"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].state = target.value;
                        setAddressArray(newAddress);
                        getCities(target.value);
                      }}
                      select
                      size="small"
                      sx={{ width: "100%" }}
                      value={addressArray[index].state}
                      variant="outlined"
                    >
                      <MenuItem disabled value=""></MenuItem>
                      {!!states &&
                        states?.map(({ id, name }) => (
                          <MenuItem key={id + name} value={Number(id)}>
                            {name}
                          </MenuItem>
                        ))}
                    </CustomTextField>
                    <CustomTextField
                      required
                      color="primary"
                      label="Cidade"
                      name="cidade"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].cityId = target.value;
                        setAddressArray(newAddress);
                      }}
                      select
                      size="small"
                      sx={{ width: "100%" }}
                      value={addressArray[index].cityId}
                      variant="outlined"
                    >
                      {!!cities &&
                        cities?.map(({ id, name }) => (
                          <MenuItem key={(id, +name)} value={Number(id)}>
                            {name}
                          </MenuItem>
                        ))}
                      <MenuItem disabled value=""></MenuItem>
                    </CustomTextField>
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <CustomTextField
                      autoComplete="off"
                      color="primary"
                      label="Latitude"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].latitude = target.value;
                        setAddressArray(newAddress);
                      }}
                      size="small"
                      sx={{ width: "341.33px" }}
                      type="text"
                      value={addressArray[index].latitude}
                      variant="outlined"
                    />
                    <CustomTextField
                      autoComplete="off"
                      color="primary"
                      label="Longitude"
                      name="longitude"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].longitude = target.value;
                        setAddressArray(newAddress);
                      }}
                      size="small"
                      sx={{ width: "341.33px" }}
                      type="text"
                      value={addressArray[index].longitude}
                      variant="outlined"
                    />
                    <CustomTextField
                      autoComplete="off"
                      color="primary"
                      label="Telefone"
                      name="telephone"
                      onChange={({ target }) => {
                        let newAddress = [...addressArray];
                        newAddress[index].telephone = target.value;
                        setAddressArray(newAddress);
                      }}
                      size="small"
                      sx={{ width: "341.33px" }}
                      type="text"
                      value={addressArray[index].telephone}
                      variant="outlined"
                    />
                  </Stack>
                </Stack>
              </>
            ))
          ) : (
            <></>
          )}
          {step === 3 ? (
            discountArray?.map((el, index) => (
              <>
                <Stack
                  spacing={2}
                  direction="row"
                  justifyContent={"flex-end"}
                  alignItems={"flex-end"}
                >
                  {index > 0 && (
                    <AiOutlineClose
                      style={{ cursor: "pointer" }}
                      size={30}
                      color="red"
                      onClick={() => {
                        if (index > 0) {
                          setDiscountArray(
                            discountArray.filter((el, mapIndex) => {
                              return mapIndex !== index;
                            })
                          );
                        }
                      }}
                    />
                  )}
                  <BiAddToQueue
                    style={{ cursor: "pointer" }}
                    size={30}
                    color="#4b9853"
                    onClick={() => {
                      setDiscountArray([...discountArray, dicountType]);
                      setTimeout(() => {
                        window.scrollTo({
                          top: 999999,
                          behavior: "smooth",
                        });
                      }, 100);
                    }}
                  />
                </Stack>
                <Stack spacing={3} justifyContent={"flex-end"}>
                  <Typography variant="h5" color={"#4b9853"}>
                    Desconto {index + 1}
                  </Typography>
                  <Stack direction="row" spacing={2} alignItems={"flex-end"}>
                    <Stack
                      sx={{ width: "100%" }}
                      justifyContent={"flex-end"}
                      alignItems={"flex-end"}
                    >
                      <Stack direction={"row"} sx={{ marginBottom: 1 }}>
                        <button
                          style={{
                            opacity:
                              discountArray[index].typeDiscount === "$"
                                ? 0.8
                                : 1,
                            cursor: "pointer",
                            border: "none",
                            color: "white",
                            background: "#4b9853",
                            width: 30,
                            height: 30,
                            borderRadius: 8,
                            boxShadow:
                              "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                          }}
                          onClick={() => {
                            let newDiscount = [...discountArray];
                            newDiscount[index].typeDiscount = "%";
                            const cleanString = discountArray[
                              index
                            ].summary.replace(/R\$|%|\$/g, "");
                            const formatTarget = cleanString + "%";
                            newDiscount[index].summary =
                              cleanString.length === 0
                                ? cleanString
                                : formatTarget;
                            setDiscountArray(newDiscount);
                          }}
                        >
                          %
                        </button>
                        <button
                          style={{
                            opacity:
                              discountArray[index].typeDiscount === "%"
                                ? 0.8
                                : 1,
                            cursor: "pointer",
                            border: "none",
                            color: "white",
                            background: "#4b9853",
                            width: 30,
                            height: 30,
                            marginLeft: 5,
                            borderRadius: 8,
                            boxShadow:
                              "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
                          }}
                          onClick={() => {
                            let newDiscount = [...discountArray];
                            newDiscount[index].typeDiscount = "$";
                            const cleanString = discountArray[
                              index
                            ].summary.replace(/R\$|%|\$/g, "");
                            const formatTarget = "R$" + cleanString;

                            newDiscount[index].summary =
                              cleanString.length === 0
                                ? cleanString
                                : formatTarget;
                            setDiscountArray(newDiscount);
                          }}
                        >
                          $
                        </button>
                      </Stack>
                      <CustomTextField
                        required
                        autoComplete="off"
                        color="primary"
                        label="Valor"
                        onChange={({ target }) => {
                          let newDiscount = [...discountArray];
                          const cleanString = target.value
                            .replace(/R\$|%|\$/g, "")
                            .replace(/[^.,\d]+/g, "");
                          const formatTarget =
                            newDiscount[index].typeDiscount === "%"
                              ? cleanString + "%"
                              : "R$" + cleanString;
                          newDiscount[index].summary =
                            cleanString.length === 0
                              ? cleanString
                              : formatTarget;
                          setDiscountArray(newDiscount);
                        }}
                        size="small"
                        sx={{ width: "100%" }}
                        type="text"
                        value={discountArray[index].summary}
                        variant="outlined"
                      />
                    </Stack>
                    <CustomTextField
                      required
                      autoComplete="off"
                      color="primary"
                      label="Titulo"
                      onChange={({ target }) => {
                        let newDiscount = [...discountArray];
                        newDiscount[index].description = target.value;
                        setDiscountArray(newDiscount);
                      }}
                      size="small"
                      sx={{ width: "100%" }}
                      type="text"
                      value={discountArray[index].description}
                      variant="outlined"
                    />
                  </Stack>
                  <Stack spacing={2}>
                    <CustomTextField
                      required
                      autoComplete="off"
                      color="primary"
                      label="Regra"
                      multiline
                      name="about"
                      rows={5}
                      onChange={({ target }) => {
                        let newDiscount = [...discountArray];
                        newDiscount[index].rule = target.value;
                        setDiscountArray(newDiscount);
                      }}
                      size="small"
                      value={discountArray[index].rule}
                      sx={{ width: "100%" }}
                      type="text"
                      variant="outlined"
                    />
                  </Stack>
                </Stack>
              </>
            ))
          ) : (
            <></>
          )}
          {/* DÉCIMA PRIMIRA LINHA */}

          {step === 4 && (
            <Stack spacing={1} alignItems={"center"} width={"100%"}>
              {/* TERMO PARCERIAS */}

              <label
                htmlFor="contained-button-file-contract"
                style={{ width: "50%" }}
              >
                <Input
                  id="contained-button-file-contract"
                  name="contract"
                  onChange={({ target }) => {
                    setContract(target.files[0]);
                  }}
                  type="file"
                  sx={{ display: "none" }}
                />
                <CustomButton
                  variant="outlined"
                  component="span"
                  endIcon={<FaFileContract />}
                  sx={{ width: "100%" }}
                >
                  {contract ? "Termo Carregado!" : "Carregar Termo"}
                </CustomButton>
              </label>

              {/* IMAGEM DE CAPA */}
              <label
                htmlFor="contained-button-file-banner"
                style={{ width: "50%" }}
              >
                <Input
                  id="contained-button-file-banner"
                  name="cover"
                  onChange={({ target }) => {
                    setCover(target.files[0]);
                  }}
                  type="file"
                  sx={{ display: "none" }}
                />
                <CustomButton
                  variant="outlined"
                  component="span"
                  endIcon={<BsCameraFill />}
                  sx={{ width: "100%" }}
                >
                  {cover ? "Capa Carregada!" : "Carregar capa"}
                </CustomButton>
              </label>

              {/* LOGO */}
              <label
                htmlFor="contained-button-file-logo"
                style={{ width: "50%" }}
              >
                <Input
                  //accept="image/*"
                  id="contained-button-file-logo"
                  name="image"
                  onChange={({ target }) => {
                    setImage(target.files[0]);
                  }}
                  type="file"
                  sx={{ display: "none" }}
                />
                <CustomButton
                  variant="outlined"
                  component="span"
                  endIcon={<FileUploadIcon />}
                  sx={{ width: "100%" }}
                >
                  {image ? "Logo Carregada!" : "Carregar logo"}
                </CustomButton>
              </label>
              <a href={termo} download>
                Não tem o Termo de parcerias?
              </a>
            </Stack>
          )}
          {step === 5 && (
            <Stack spacing={2}>
              <CustomTextField
                required
                autoComplete="off"
                color="primary"
                label="Observação para análise"
                multiline
                name="comments"
                rows={5}
                onChange={({ target }) => {
                  setComments(target.value);
                }}
                size="small"
                value={comments}
                sx={{ width: "100%" }}
                type="text"
                variant="outlined"
              />
            </Stack>
          )}
          <Stack
            direction="row"
            spacing={1}
            py={2}
            justifyContent={"space-between"}
            width={"100%"}
          >
            {/* BOTÃO DE SUBMIT */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CustomButton
                sx={{ width: 150 }}
                type="submit"
                variant="contained"
                onClick={() => handleChangeStep({ type: "less" })}
                disabled={step > 0 ? false : true}
              >
                Anterior
              </CustomButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CustomButton
                sx={{ width: 300 }}
                type="submit"
                variant="contained"
                onClick={() => handleChangeStep({ type: "more" })}
                disabled={isLoading ? true : checkDisabledButton()}
              >
                {step === 5 && !isLoading
                  ? "Cadastrar"
                  : isLoading
                  ? "Carregando..."
                  : "Próximo"}
              </CustomButton>
            </Box>
          </Stack>
        </Stack>
      </CustomContainer>
    </Container>
  );
}
